var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E4E4E4",
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56 82.44c-5.82.19-11.61-.917-16.949-3.241C46.643 89.262 22.12 74.909 22.12 51.72a30.72 30.72 0 1 1 55.487 18.178c.656 3.866 2.129 9.364 5.953 12.542z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.56 82.44c-5.82.19-11.61-.917-16.949-3.241A30.328 30.328 0 0 1 52.84 82.44v-3.708a3.686 3.686 0 0 0-3.686-3.707h-1.23a3.708 3.708 0 0 1 0-7.415h6.145a3.686 3.686 0 0 0 3.686-3.708 3.708 3.708 0 0 1 3.687-3.708h20.932a30.328 30.328 0 0 1-4.767 9.693c.656 3.877 2.129 9.375 5.953 12.553zM51.611 54.368a3.687 3.687 0 0 1-3.686 3.708H22.777a30.794 30.794 0 0 1 3.77-22.246H43.01a3.708 3.708 0 1 1 0 7.416h-4.916a3.708 3.708 0 0 0 0 7.415h9.83a3.686 3.686 0 0 1 3.687 3.707zM83.475 49.601H66.357a3.686 3.686 0 0 1-3.687-3.707 3.708 3.708 0 0 0-3.686-3.708h-1.229a3.708 3.708 0 1 1 0-7.415H63.9a3.686 3.686 0 0 0 3.687-3.708 3.708 3.708 0 0 1 3.686-3.707l.106-.127A30.593 30.593 0 0 1 83.475 49.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M61.143 81.367c14.888-5.13 22.332-15.01 22.332-29.637s-7.444-24.478-22.332-29.555c8.456 8.022 12.684 17.556 12.684 28.602s-4.228 21.242-12.684 30.59z",
    fill: "#D8D8D8",
    opacity: 0.304
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobusCircle);
export default __webpack_public_path__ + "static/media/globus-circle.cf70e8a9f0bed0dfa4152eac479e2443.svg";
export { ForwardRef as ReactComponent };